<div class="container-layout">
  <app-sidebar></app-sidebar>
  <div>
    <app-toolbar></app-toolbar>
    <router-outlet></router-outlet>
  </div>
</div>
